import { Grid, Layout, Paper, Table, Loader } from "../../components";
import moment from "moment";
import { useAxios } from '../../hooks'
import { Fragment } from "react";
import { Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function Agencies () {
    const navigate = useNavigate()
    const [agencies] = useAxios(`/user?role=AGENCY`)
    
    return (
        <Layout>
            <Grid container justifyContent="center" padding={3} spacing={2}>
                {agencies.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : (
                    <Fragment>
                <Grid item xs={12} sm={10}>
                    <Paper elevation={1}>
                    <Table 
                        columns={[
                            { field: 'id', headerName: 'ID', width: 100 },
                            { field: 'created_at', headerName: 'Criado em', width: 200, valueFormatter: ({value}) => {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            } },
                            { field: 'name', headerName: 'Nome', flex: 1, renderCell: ({row, value}) => {
                                return (
                                    <Link href={`/admin/usuarios/${row.id}`}>
                                        {value}
                                    </Link>
                                )
                            }},
                        ]}
                        rows={(agencies?.data || [])}
                    />
                    </Paper>
                </Grid>
                </Fragment>)}
            </Grid>
        </Layout>
    )
}